import React, { useContext, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import { URL } from '../../../config/api';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import { enableSpinner, disableSpinner, setAuthState } from '../../../redux/actions/appActions';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../App/authContext';

const LogInForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email,setEmail] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();
  const func = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(email === '') { validate('email'); return; }
    if(password === '') { validate('password'); return; }

    dispatch(enableSpinner('Sign in..'));
    try {
      const bodyFormData = new FormData();
      bodyFormData.append('Email', email);
      bodyFormData.append('Password', password);
      const res = await axios.post(`${URL}/login/login_admin.php`, bodyFormData);
      if(res.data.Success) {
        localStorage.setItem('auth', true);
        localStorage.setItem('token', res.data.Data.Token);
        localStorage.setItem('id', res.data.Data.Id)
        localStorage.setItem('type', res.data.Data.Type);
        console.log("AAA_TYPE", res.data.Data.Type);
        if(res.data.Data.Type == 0) {
          history.push('/projects')
        } else {
          history.push('/users')
        }
        func();
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log('error');
    }
    
    dispatch(disableSpinner());
  }

  const validate = (param) => {
    alert(`Please fill ${param} please!`);
  }

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Username</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <AccountOutlineIcon />
          </div>
          <Field
            name="email"
            component="input"
            type="text"
            placeholder="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">Password</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <KeyVariantIcon />
          </div>
          <Field
            name="password"
            component="input"
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className={`form__form-group-button${showPassword ? ' active' : ''}`}
            onClick={() => setShowPassword(!showPassword)}
            type="button"
          ><EyeIcon />
          </button>
        </div>
      </div>
      
      <button className="btn btn-primary account__btn account__btn--small">Sign In</button>
    </form>
  );
};

export default reduxForm({
  form: 'log_in_form',
})(LogInForm);
